<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="监控模板" prop="template_name">
        <el-select v-model="initForm.template_name" placeholder="请选择监控模板">
        <el-option
          v-for="templateType in monitorTemplateTypeList"
          :label="templateType"
          :key="templateType"
          :value="templateType"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="监控指标" prop="metric_name">
        <el-select v-model="initForm.metric_name" placeholder="请选择监控指标">
        <el-option
          v-for="metric in deviceMonitorMetricsList"
          :label="metric"
          :key="metric"
          :value="metric"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="监控命令" prop="cmd">
        <el-input type="textarea" v-model="initForm.cmd" placeholder="请输入具体命令, 例如 cat /temp/abc.txt" :rows="6"></el-input>
      </el-form-item>

      <el-form-item label="数据处理命令" prop="pipeline">
        <el-input type="textarea" v-model="initForm.pipeline" placeholder="请输入具体命令, 例如 grep dclient | wc -l" :rows="6"></el-input>
      </el-form-item>

      <el-form-item label="是否启用" prop="switch">
        <el-select v-model="initForm.switch" placeholder="启用或关闭设备监控">
        <el-option
          v-for="status in switchStatus"
          :label="status"
          :key="status"
          :value="status"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="监控项说明" prop="desc">
        <el-input type="textarea" v-model="initForm.desc" placeholder="监控项说明"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SwitchStatus } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    monitorTemplateTypeList: {},
    deviceMonitorMetricsList: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        template_name: [{required: true, message: "请选择监控", trigger: "blur"}],
        metric_name: [{required: true, message: "请选择监控指标", trigger: "blur"}],
        cmd: [{required: true, message: "请输入具体命令, 例如 ps -ef | grep dclient", trigger: "blur"}],
        status: [{required: true, message: "启用或禁用监控项", trigger: "blur"}],
        desc: [{required: false, message: "请输入模板说明", trigger: "blur"}]
      },
      titles: {
        add: "新增-模板监控项",
        edit: "编辑-模板监控项"
      },
      switchStatus: SwitchStatus
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              template_name: this.initForm.template_name,
              metric_name: this.initForm.metric_name,
              cmd: this.initForm.cmd,
              pipeline: this.initForm.pipeline,
              status: +(this.initForm.switch === '开启'),
              desc: this.initForm.desc
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-monitor/template-item/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-monitor/template-item/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
